import { render, staticRenderFns } from "./FocusesSuccessReport.vue?vue&type=template&id=bc45df04&scoped=true"
import script from "./FocusesSuccessReport.vue?vue&type=script&lang=js"
export * from "./FocusesSuccessReport.vue?vue&type=script&lang=js"
import style0 from "./FocusesSuccessReport.vue?vue&type=style&index=0&id=bc45df04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45df04",
  null
  
)

export default component.exports